import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";

/**
 * Componente responsável por renderizar ícones svg.
 */
@Component({
    selector: "nms-svg-icon",
    templateUrl: "./nms-svg-icon.component.html",
    styleUrls: ["./nms-svg-icon.component.scss"]
})
export class NmsSvgIcon implements AfterViewInit {
    @Input() name: string;
    @Input() prefix: string = "";
    @Input() customFolder: string;
    @Input() customStyle: string = "";

    @ViewChild("iconElement") element: ElementRef<HTMLLIElement>;

    private readonly iconsFolder = "/images/icons/default/";

    ngAfterViewInit(): void {
        const folder = this.customFolder || this.iconsFolder;
        const image = this.name.endsWith(".svg") ? this.name : `${this.name}.svg`;
        this.element.nativeElement.setAttribute("style", `background-image: url(${folder}${image});${this.customStyle}`);
    }
}
